import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { css } from "emotion";
import { Waypoint } from "react-waypoint";

import Container from "components/shared/Container";
import Spinner from "components/shared/Spinner";
import Product from "./Product";

import styleConfig from "styles/styleConfig";
import { getProducts, IProduct } from "api/heroku";

const { colors, margin, padding, fontSize } = styleConfig;

const productsStyle = css`
  .container {
    margin: ${margin[8]} 0;
    padding: ${padding[4]};
    h1 {
      margin: ${margin[4]} 0;
      font-size: ${fontSize.md};
      text-transform: uppercase;
    }
  }
  .content {
    .products {
      display: flex;
      flex-flow: row wrap;
    }
  }
`;

interface Props {}

const FeaturedProducts: React.FC<Props> = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [show, setShow] = useState<boolean>(false);
  const [products, setProducts] = useState<IProduct[]>([]);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const response = await getProducts();
      setProducts(response.slice(0, 4));
      setLoading(false);
    }
    fetchData();
  }, []);

  const renderProducts = products.map(product => (
    <Product
      key={product.id}
      image={product.image}
      price={product.price}
      title={product.name}
      oldPrice={product.oldPrice}
      unit={product.unit}
    />
  ));
  return (
    <div className={productsStyle}>
      <Container className="container">
        <h1>{t(`home.top_offers`)}</h1>
        <div className="content">
          <Waypoint onEnter={() => setShow(true)} />
          <p
            className={css`
              padding: 1rem;
              margin-bottom: 2rem;
              border-radius: 0.5rem;
              background-color: ${colors.secondary[200]};
              color: ${colors.secondary[600]};
            `}
          >
            In de toekomst zullen er meer producten toegevoegd worden.
          </p>
          {show && <>{products.length ? <div className="products">{renderProducts}</div> : loading && <Spinner />}</>}
        </div>
      </Container>
    </div>
  );
};

export default FeaturedProducts;
